(function () {
  const initAnimation = (section) => {
    if (!section || !section.querySelector(".animate-on-scroll")) return;

    const footerBlocksContainer = section.querySelector(".footer-blocks");

    if (!footerBlocksContainer) return;

    const footerBlocks = footerBlocksContainer.querySelectorAll(
      ".footer-block, .accordion"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          footerBlocks.forEach((block) => {
            gsap.fromTo(
              block,
              {
                maskPosition: "100% 0%",
              },
              {
                maskPosition: "0% 0%",
                duration: 1.75,
                ease: "ease",
                onComplete: () => {
                  block.style.webkitMaskImage = "none";
                  block.style.maskImage = "none";
                },
              }
            );
          });
          observer.disconnect();
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(footerBlocksContainer);
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();


/*Site Credits*/

document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll("[data-footer-site-credits]");
  if (!wrappers.length) return;

  wrappers.forEach((wrap) => {
    const trigger = wrap.querySelector(".footer-site-credits__trigger");
    const popover = wrap.querySelector(".footer-site-credits__popover");
    if (!trigger || !popover) return;

    const open = () => {
      wrap.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    };

    const close = () => {
      wrap.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    };

    // Toggle
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      wrap.classList.contains("is-open") ? close() : open();
    });

    // Close when clicking anywhere inside popover
    popover.addEventListener("click", () => {
      close();
    });

    // Close when clicking outside
    document.addEventListener("click", (e) => {
      if (!wrap.contains(e.target)) close();
    });

    // Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });
  });
});




